export var UNPLANNED = 'N';
export var DAYS = [{
  num: 1,
  name: App.lang('Mon')
}, {
  num: 2,
  name: App.lang('Tue')
}, {
  num: 3,
  name: App.lang('Wed')
}, {
  num: 4,
  name: App.lang('Thu')
}, {
  num: 5,
  name: App.lang('Fri')
}, {
  num: 6,
  name: App.lang('Sat')
}, {
  num: 7,
  name: App.lang('Sun')
}];
export var EMPTY_LABEL = {
  value: null,
  label: App.lang('Empty')
};
export var RESET_PROP = '__very_unique_prop_used_to_indicate_we_wish_to_reset_something';
export var STATE_DELETED = 0;
export var STATE_TRASHED = 1;
export var STATE_ARCHIVED = 2;
export var STATE_VISIBLE = 3;
export var WARN_COLOR_INPUT = '#ffb7b7';
export var WARN_COLOR_ROW = '#f0d7d7';